import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import { useNavigate } from 'react-router-dom';
import { destinations } from '../data/Destination';
import deafultImage from "../assets/tour-package.jpg"

const InternationalPackages = () => {
    const navigate = useNavigate();
    return (
        <>
            {Array.isArray(destinations) && destinations.length > 0 && (
                <>
                    <div className="bg-[#0B1C3D] py-2">
                        <div className={`mt-6 max-lg:mx-6 mx-6 text-start border-l-8 rounded-r-full bg-[#0B1C3D]  border-[#D4AF37] wow fadeInUp max-sm:w-[70%] xl:w-[50%] transform -skew-x-12 `} data-wow-delay="0.1s"
                        >
                            {/* Heading */}
                            <h1 className=" playfair-display font-extrabold py-[6px] px-2 max-lg:text-xl text-2xl text-white">
                                International Tour Packages
                            </h1>
                            {/* <h6 className="mb-5 max-sm:text-lg text-white ">Fly to Your Dream Destination Today</h6> */}
                        </div>
                     
                        <div className="flex justify-center items-center mb-5  relative w-[100%] max-sm:px-0 xl:mx-4 mx-0">
                            <Swiper
                                modules={[Pagination, Autoplay]}
                                spaceBetween={15}
                                slidesPerView={1}
                                breakpoints={{
                                    0: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    480: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    640: {
                                        slidesPerView: 2,
                                        direction: "horizontal",
                                    },
                                    768: {
                                        slidesPerView: 3,
                                        direction: "horizontal",
                                    },
                                    1024: {
                                        slidesPerView: 4,
                                        direction: "horizontal",
                                    },
                                    1280: {
                                        slidesPerView: 5,
                                        direction: "horizontal",
                                    },
                                }}
                                loop={true}
                                // navigation={true}
                                autoplay={{ delay: 3000, disableOnInteraction: false }}
                                // pagination={{ clickable: true }} 
                                className=" relative flex flex-col w-full h-[60vh] max-xs:h-[40vh] cursor-pointer"
                                style={{ padding: "20px" }}
                            >
                                {destinations?.filter(d => d?.categories?.includes("international"))?.map((pkg, index) => (
                                    <SwiperSlide key={pkg.id || index}>
                                        <div
                                            className={`relative   bg-[#ffffff] border-1 border-[#D4AF37]      rounded-xl text-white flex flex-col items-center h-full`}
                                            style={{ boxShadow: ' 0px 0px 20px 5px rgb(212 175 55 / 70%)' }}
                                            onClick={() => navigate(pkg?.link)}
                                        >
                                            {/* Left Side - Offer Image */}
                                            <div
                                                className="absolute  w-full h-full overflow-hidden rounded-xl cursor-pointer"

                                            >
                                                <img
                                                    src={pkg?.image || deafultImage}
                                                    alt={pkg?.title || "destination"}
                                                    loading="lazy"
                                                    className="w-full rounded-xl  h-full object-cover hover:scale-110 transition duration-500"
                                                />
                                                <div className="absolute inset-0 bg-black opacity-50"></div>

                                            </div>
                                            {/* Right Side - Offer Details */}
                                            <div className="z-10 w-[100%] h-full  mt-3 py-1 ml-1 px-1 overflow-hidden flex items-center justify-end flex-col">
                                                <h2 className="text-[#ffffff] text-start mb-1 text-[18px]  md:text-xl lg:text-xl xl:text-2xl font-semibold playfair-display">
                                                    {pkg?.name} Packages
                                                </h2>
                                                <p className="text-xs sm:text-sm md:text-base lg:text-[16px] text-white poppins mb-0">
                                                    <span>
                                                        From{" "}
                                                        <span className="text-sm sm:text-base md:text-lg lg:text-[16px] font-bold">
                                                            ₹{pkg?.price || "N/A"}/-
                                                        </span>
                                                    </span>{" "}
                                                    <span className="text-[9px] sm:text-[10px] md:text-xs  lg:text-[12px]">
                                                        Per Person
                                                    </span>
                                                </p>
                                                <div className="mt-2 flex  items-start md:flex-row lg:flex-row xl:flex-row  w-full">
                                                    <div className="hidden flex justify-start mr-1 mb-1"> {/* Container alignment adjust karein */}
                                                        <a
                                                            href={pkg?.link}
                                                            rel="noopener noreferrer"
                                                            className="no-underline "
                                                        >
                                                            <button
                                                                type="submit"
                                                                className=" 
        relative z-10 overflow-hidden group flex items-center justify-center gap-2 
      rounded-full  shadow-xl isolation-auto transition-all duration-700
      
      /* Colors */
      bg-[#0B1C3D] text-[#D4AF37] hover:text-gray-50
      
      /* Responsive Sizing (Mobile first) */
      px-3 py-2 text-sm           /* Default: Mobile */
      sm:px-6 sm:py-3 sm:text-sm /* Tablets */
      lg:px-8 lg:py-3 lg:text-sm   /* Desktop */
      lg:font-semibold
      
      /* Hover Effect Logic */
      before:absolute before:w-full before:transition-all before:duration-700 
      before:-left-full before:hover:left-0 before:rounded-full before:bg-[#D4AF37] 
      before:-z-10 before:aspect-square before:hover:scale-150
    "
                                                            >
                                                                <span className="whitespace-nowrap">View</span>
                                                                <svg
                                                                    className="
        shrink-0 ease-linear duration-300 rounded-full border border-[#D4AF37] p-2 rotate-45
        
        /* Responsive Icon Size */
           w-6 h-6   /* Mobile */
        sm:w-7 sm:h-7 /* Tablet/Desktop */
        
        /* Hover States */
        group-hover:rotate-90 group-hover:bg-gray-50 group-hover:border-none
      "
                                                                    viewBox="0 0 16 19"
                                                                    xmlns="http://www.w3.org/2000/svg"
                                                                >
                                                                    <path
                                                                        d="M7 18C7 18.5523 7.44772 19 8 19C8.55228 19 9 18.5523 9 18H7ZM8.70711 0.292893C8.31658 -0.0976311 7.68342 -0.0976311 7.29289 0.292893L0.928932 6.65685C0.538408 7.04738 0.538408 7.68054 0.928932 8.07107C1.31946 8.46159 1.95262 8.46159 2.34315 8.07107L8 2.41421L13.6569 8.07107C14.0474 8.46159 14.6805 8.46159 15.0711 8.07107C15.4616 7.68054 15.4616 7.04738 15.0711 6.65685L8.70711 0.292893ZM9 18L9 1H7L7 18H9Z"
                                                                        className="fill-[#D4AF37]"
                                                                    ></path>
                                                                </svg>
                                                            </button>
                                                        </a>
                                                    </div>

                                                </div>
                                            </div>
                                        </div>

                                    </SwiperSlide>
                                ))}
                            </Swiper>
                        </div>

                    </div>
                </>
            )}
        </>
    );
};

export default InternationalPackages;
